export const arrayToObject = (key = '', array = []) => {
	return array.reduce(
		(acc, obj) =>
			Object.assign(acc, {
				[obj[key]]: obj
			}),
		{}
	);
};

export const regexExtract = (rgxFormat, value) => {
	let formatted = '';
	if (value) {
		const stringMatch = value.match(rgxFormat);
		formatted = stringMatch ? stringMatch[1] : formatted;
	}
	return formatted;
};

